/**
 * Demo stock lots — FEFO-orderable lots per product. Includes expired,
 * nearly-expired and healthy lots so the alerts dashboard has real data.
 */
import { dateOffsetYmd } from "../uuid.js";

export function buildStockLots(produits) {
  const lots = [];
  let i = 1;

  for (const prod of produits) {
    if (prod.statut_produit === "BLOQUE_CACHE") continue;
    const stock = prod.stock_actuel || 0;
    if (stock <= 0) continue;

    // Split stock across 1-3 lots with varying expiry windows
    const lotCount = stock > 80 ? 3 : stock > 25 ? 2 : 1;
    const portions = splitInteger(stock, lotCount);
    portions.forEach((qty, idx) => {
      const monthsAhead = idx === 0
        ? expiryOffsetFor(prod.id, idx)
        : 8 + idx * 9;
      lots.push({
        id: `lot-${pad(i)}`,
        produit_id: prod.id,
        numero_lot: `${prod.id.slice(-3)}-${pad(i)}`,
        quantite_initiale: qty,
        quantite_actuelle: qty,
        date_peremption: dateOffsetYmd(monthsAhead * 30),
        date_fabrication: dateOffsetYmd(-180),
        prix_achat_ht: round(prod.ppa * 0.55),
        prix_achat_ttc: round(prod.ppa * 0.62),
        achat_id: idx === 0 ? "achat-100" : null,
        statut: "ACTIF",
        location: prod.type_produit === "MEDICAMENT" ? "A1" : "B2",
      });
      i += 1;
    });
  }

  // Add some explicitly-expired or near-expiry lots for alert dashboards
  if (produits.find((p) => p.id === "p-002")) {
    lots.push({
      id: "lot-expired-001",
      produit_id: "p-002",
      numero_lot: "EXP-PERIME-01",
      quantite_initiale: 25,
      quantite_actuelle: 25,
      date_peremption: dateOffsetYmd(-15),
      date_fabrication: dateOffsetYmd(-720),
      prix_achat_ht: 78,
      prix_achat_ttc: 88,
      achat_id: null,
      statut: "ACTIF",
      location: "A1",
    });
    lots.push({
      id: "lot-near-001",
      produit_id: "p-002",
      numero_lot: "PROCHE-PEREMPT-01",
      quantite_initiale: 18,
      quantite_actuelle: 18,
      date_peremption: dateOffsetYmd(45),
      date_fabrication: dateOffsetYmd(-540),
      prix_achat_ht: 78,
      prix_achat_ttc: 88,
      achat_id: null,
      statut: "ACTIF",
      location: "A1",
    });
  }

  return lots;
}

function expiryOffsetFor(id, idx) {
  // Deterministic-ish — derive from id char codes
  const seed = id.charCodeAt(id.length - 1) + id.charCodeAt(id.length - 2);
  if (idx > 0) return 12 + idx * 6;
  return 4 + (seed % 18); // 4-22 months out
}

function splitInteger(total, n) {
  if (n <= 1) return [total];
  const base = Math.floor(total / n);
  const rem = total - base * n;
  return Array.from({ length: n }, (_, i) => base + (i < rem ? 1 : 0));
}

function pad(n) {
  return String(n).padStart(4, "0");
}
function round(n) {
  return Math.round(n * 100) / 100;
}
